import React, { useState, useEffect } from "react";
import Entry from "./Entry";

const Entries = (props) => {
  const [entriesData, setEntriesData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [isLoading, setLoading] = useState(false);

  const fetchEntriesData = () => {
    setLoading(true);
    console.log("pagenum b: %i", pageNum);
    fetch("http://www.amusing.org/read.php?page=" + pageNum)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setEntriesData(data.result);
        setLoading(false);
        console.log("pagenum a: %i", pageNum);
      });
  };

  const nextPage = () => {
    setPageNum((prev) => {
      return prev + 1;
    });
  };
  const prevPage = () => {
    setPageNum((prev) => {
      return prev - 1;
    });
  };
  useEffect(() => { fetchEntriesData() }, [pageNum]);

  return (
    <div>
      {entriesData.map((entry) => {
        return (
          <Entry
            key={entry.id}
            entry={entry.entry}
            sentBy={entry.sent_by}
            shownOn={entry.shown_on}
          />
        );
      })}
      <p>
      <button onClick={prevPage} disabled={isLoading}>
          prev page
        </button>
        - page {pageNum} -
        <button onClick={nextPage} disabled={isLoading}>
          next page
        </button>
      </p>
    </div>
  );
};

export default Entries;
